exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre{overflow:auto;word-wrap:normal;margin:0;padding:.85em 1em;margin-bottom:1.275em;background-color:#f0fafa;margin:6px 0}.deploy-description,.deploy-title{margin:10px 0}.deploy_content{padding:10px;box-sizing:content-box;width:100%;overflow:auto}.deploy_content p{font-size:16px;line-height:24px}.deploy-desc{line-height:26px}.deploy-desc,.deploy-desc p{font-size:14px}.deploy-list,.deploy-list p{font-size:13px}.user{padding-left:36px}.el-table .cell{text-align:center}pre{font-family:Consolas,Menlo,Courier,monospace}.deploy_content .el-table__body,.deploy_content .el-table__header{margin:0}", ""]);

// exports
